module.exports = __webpack_public_path__ + "resources/img/img_intermax_1_m.c89cc32160099ff3b0f8ec08d2ed5314.png";